import React from "react";
import HeadMeta from "@/components/common/HeadMeta";
import Contact from "@/components/sections/Contact";

export default function contacto() {
    const metaData = {
        title: "Contáctanos - Servicios Contables y Bookkeeping en Miami",
        keywords: "contactar servicios contables Miami, bookkeeping personalizado Miami, soluciones financieras Miami",
        description: "¿Buscas servicios contables y bookkeeping en Miami? Contáctanos en Actionis Consulting. Somos tu aliado para soluciones financieras personalizadas."
    }
    return (
        <section className="pt-24 md:pt-44">
            <h1 className="sr-only">Contacto

            </h1>
            <HeadMeta {...metaData} />
            <Contact />
        </section>
    );
}
